export { default } from './withScaleRatingIcons';
